import { render, staticRenderFns } from "./SyllabusSubEffectsModalSearch.vue?vue&type=template&id=9ef8ab82&"
import script from "./SyllabusSubEffectsModalSearch.vue?vue&type=script&lang=js&"
export * from "./SyllabusSubEffectsModalSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports